import { render, staticRenderFns } from "./DteRelatedDocumentsSection.vue?vue&type=template&id=7cc7ece8"
import script from "./DteRelatedDocumentsSection.vue?vue&type=script&lang=js"
export * from "./DteRelatedDocumentsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports